import { Component, OnInit, ViewChild, HostListener, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AppSettings } from '../app.settings';
import { Settings } from '../app.settings.model';
import { MenuService } from '../theme/components/menu/menu.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { GlobalFunction } from '../shared/global-function';
import { AuthResponseData } from '../shared/models/authentication/auth-response-data';
import { EmployeeService } from '../shared/services/employee.service';
import { IEmployee } from '../shared/models/employee/employee.model';
import { TutorialService } from '../shared/services/tutorial.service';

@Component({
    selector: 'app-pages',
    templateUrl: './pages.component.html',
    styleUrls: ['./pages.component.scss'],
    providers: [MenuService]
})
export class PagesComponent implements OnInit, OnDestroy
{
    @ViewChild('sidenav') sidenav: any;
    @ViewChild('backToTop', { static: true }) backToTop: any;
    public settings: Settings;

    private subscriptions: Subscription[] = [];

    results: Object;
    searchTerm$ = new Subject<string>();

    authResponseData: AuthResponseData;
    public userName = '';
    private employee: IEmployee;

    public currentRoute: string = "";

    constructor(
        public appSettings: AppSettings,
        public router: Router,
        private menuService: MenuService,
        private translate: TranslateService,
        private employeeService: EmployeeService,
        private tutorialService: TutorialService
    )
    {
        this.settings = this.appSettings.settings;
        translate.setDefaultLang('de');
        router.events.subscribe(val =>
        {
            this.currentRoute = this.currentRoute = router.url;
        });
    }

    ngOnInit()
    {
        if (window.innerWidth <= 768)
        {
            this.settings.menu = 'vertical';
            this.settings.sidenavIsOpened = false;
            this.settings.sidenavIsPinned = false;
        }

        if (!GlobalFunction.isEmpty(localStorage.getItem('AppointmentManagementUser')))
        {
            this.authResponseData = JSON.parse(localStorage.getItem('AppointmentManagementUser'));
            this.userName = this.authResponseData.userName;
            // can be more then one
            // this.roles = this.authResponseData.userRoles.toString();
            this.subscriptions.push(this.employeeService.get(this.authResponseData.userId).subscribe(data =>
            {
                this.employee = data;
            }));
        }
    }

    ngAfterViewInit()
    {
        this.subscriptions.push(this.router.events.subscribe(event =>
        {
            if (event instanceof NavigationEnd)
            {
                if (!this.settings.sidenavIsPinned)
                {
                    this.sidenav.close();
                }
                if (window.innerWidth <= 768)
                {
                    this.sidenav.close();
                }
            }
            this.settings.loadingSpinner = false;
        }));
        if (this.settings.menu == 'vertical')
        {
            this.menuService.expandActiveSubMenu(this.menuService.getAlphabeticalMenuItems());
        }
    }

    public showTutorial(): void 
    {
        this.tutorialService.showTutorial();
    }

    public stopTutorial(name: string): void
    {
        this.tutorialService.endTutorialComponent(name);
    }

    public toggleSidenav()
    {
        this.sidenav.toggle();
    }


    @HostListener('window:resize')
    public onWindowResize(): void
    {
        if (window.innerWidth <= 768)
        {
            this.settings.sidenavIsOpened = false;
            this.settings.sidenavIsPinned = false;
            this.settings.menu = 'vertical';
        } else
        {
            this.settings.menu = 'vertical';
            this.settings.sidenavIsOpened = true;
            this.settings.sidenavIsPinned = true;
        }
    }

    public closeSubMenus()
    {
        const menu = document.querySelector('.sidenav-menu-outer');
        if (menu)
        {
            for (let i = 0; i < menu.children[0].children.length; i++)
            {
                const child = menu.children[0].children[i];
                if (child)
                {
                    if (child.children[0].classList.contains('expanded'))
                    {
                        child.children[0].classList.remove('expanded');
                        child.children[1].classList.remove('show');
                    }
                }
            }
        }
    }


    switchLanguage(language: string)
    {
        this.translate.use(language);
    }

    ngOnDestroy()
    {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

}
